
// $(document).ready(function() {
//     grecaptcha.render('recaptcha-container', {
//         'sitekey': '6LetzgEqAAAAAIwxylNs_PttmjvE0yd-KqjfkCTh' // Reemplaza con tu clave de sitio de reCAPTCHA
//     });
// });